import { render, staticRenderFns } from "./AddMedium.vue?vue&type=template&id=b10c4bee&scoped=true&"
import script from "./AddMedium.vue?vue&type=script&lang=js&"
export * from "./AddMedium.vue?vue&type=script&lang=js&"
import style0 from "./AddMedium.vue?vue&type=style&index=0&id=b10c4bee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10c4bee",
  null
  
)

export default component.exports